import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedPriceListSalesman, selectPriceListSalesmanState, setAction } from "../redux/slices/priceListSalesmanSlice"
import { priceListSalesmanAPI } from "../apis/priceListSalesmanAPI"
import { priceListSalesman } from "../types/slices/priceListSalesmanType"

export const usePriceListSalesmanStore = () => {

    const dispatch = useDispatch()
    const { priceListSalesman, priceListSelectedSalesman, status, action } = useSelector(selectPriceListSalesmanState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getPriceListSalesman = async (data:{}) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListSalesmanAPI.getPriceListSalesman(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createPriceListSalesman = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListSalesmanAPI.createPriceListSalesman(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editPriceListSalesman = async (idlist: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListSalesmanAPI.editPriceListSalesman(idlist, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deletePriceListSalesman = async (idlist: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await priceListSalesmanAPI.deletePriceListSalesman(idlist)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedPriceListSalesman = (detail: priceListSalesman) => {
        try {
            dispatch(onSetSelectedPriceListSalesman(detail))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionPriceListSalesman = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        priceListSalesman,
        priceListSelectedSalesman,
        status,
        action,
        //actions
        getPriceListSalesman,
        createPriceListSalesman,
        editPriceListSalesman,
        deletePriceListSalesman,
        setSelectedPriceListSalesman,
        setActionPriceListSalesman,
    }
}